(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('physicalFairsReportController', physicalFairsReportController);
    physicalFairsReportController.$inject = [];
    function physicalFairsReportController() {
        var vm = this;
        vm.result  = [];

        function active() {

        }

        active();
    }
})();
